import React from "react";
import Button from "../Button";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { Title } from "@components/_Revamp/Typography/Title.stories";
import { useHistory } from "react-router-dom";
import { styled } from "@linaria/react";
import { SCREEN_SIZE } from "@static/screen-size";
import { ROUTE_PATH } from "@static/route-paths";

function TrenchesLimit({ closeModal }: { closeModal: () => void }) {
  const history = useHistory();
  return (
    <>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <Title variant="title" maxWidht={450} align="center">
        Thank you for your interest in our product
        </Title>
      </div>
      <Para>
        <div className="modalPara">
        <div>We've closed the tranche for this cycle.</div>
<div>Leave your contact details and we'll let you know when the next tranche is available.</div>
        </div>
      </Para>
      <ButtonContainerModal>
        <Button
          variant="secondary"
          hoverBgColor={EverGreenStyle.colors.primary}
          hoverTextColor={EverGreenStyle.colors.white}
          label="Back to home"
          onClick={closeModal}
        />
        <Button
          variant="default"
          label="Join the waitlist"
          onClick={() => {
            history.push(
              ROUTE_PATH.EVER_GREEN_CONTACTUS + "?previous=reachLimit"
            );
          }}
        />
      </ButtonContainerModal>
    </>
  );
}

export default TrenchesLimit;

const USToolTipStyle = styled.ul`
  list-style: disc;
`;

const ButtonContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 100px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  button {
    cursor: pointer;
  }
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    flex-direction: row;
  }
`;
const ButtonContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  margin: 0 auto;
  max-width: 424px;
  justify-content: center;
  align-items: center;
  @media screen and (min-width: ${`${SCREEN_SIZE.mobilesUp}px`}) {
    flex-direction: row;
  }
`;

const Para = styled.p<{ noMargin?: boolean }>`
  font-size: ${EverGreenStyle.fontSize.xs}px;
  font-weight: 600;
  letter-spacing: 0.18px;
  color: ${EverGreenStyle.colors.grey[1200]};
  margin-bottom: ${(props) => (props.noMargin ? "unset" : "29px")};

  .modalPara {
    width: 100%;
    text-align: center;
    font-size: ${EverGreenStyle.fontSize.description}px;
    font-weight: 600;
  }

  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
  margin-bottom: ${(props) => (props.noMargin ? "unset" : "64px")};
    
  }
`;
